// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';
import ConfirmBeforeUnload from 'esm-web-pro/components/dialogs/ConfirmBeforeUnload';
import { getCallState } from 'esm-web-pro/redux/callings';
import { isEmpty } from 'lodash';

const ConfirmBeforeUnloadWithCall = () => {
    const callingState = useSelector(getCallState);

    return callingState && !isEmpty(callingState) ? (
        <ConfirmBeforeUnload />
    ) : null;
};

export default ConfirmBeforeUnloadWithCall;
